import keyBy from 'lodash/keyBy';

import { GlobalAction, CustomReportsState } from '.';

const GET_CUSTOM_REPORTS_START = 'GET_CUSTOM_REPORTS_START';
const GET_CUSTOM_REPORTS_ERROR = 'GET_CUSTOM_REPORTS_ERROR';
const GET_CUSTOM_REPORTS_SUCCESS = 'GET_CUSTOM_REPORTS_SUCCESS';
const GET_CUSTOM_REPORT_START = 'GET_CUSTOM_REPORT_START';
const GET_CUSTOM_REPORT_ERROR = 'GET_CUSTOM_REPORT_ERROR';
const GET_CUSTOM_REPORT_SUCCESS = 'GET_CUSTOM_REPORT_SUCCESS';
const ADD_CUSTOM_REPORTS_START = 'ADD_CUSTOM_REPORTS_START';
const ADD_CUSTOM_REPORTS_ERROR = 'ADD_CUSTOM_REPORTS_ERROR';
const ADD_CUSTOM_REPORTS_SUCCESS = 'ADD_CUSTOM_REPORTS_SUCCESS';
const EDIT_CUSTOM_REPORTS_START = 'EDIT_CUSTOM_REPORTS_START';
const EDIT_CUSTOM_REPORTS_ERROR = 'EDIT_CUSTOM_REPORTS_ERROR';
const EDIT_CUSTOM_REPORTS_SUCCESS = 'EDIT_CUSTOM_REPORTS_SUCCESS';
const DELETE_CUSTOM_REPORTS_START = 'DELETE_CUSTOM_REPORTS_START';
const DELETE_CUSTOM_REPORTS_ERROR = 'DELETE_CUSTOM_REPORTS_ERROR';
const DELETE_CUSTOM_REPORTS_SUCCESS = 'DELETE_CUSTOM_REPORTS_SUCCESS';

const ADD_RECURRING_START = 'ADD_RECURRING_START';
const ADD_RECURRING_ERROR = 'ADD_RECURRING_ERROR';
const ADD_RECURRING_SUCCESS = 'ADD_RECURRING_SUCCESS';
const EDIT_RECURRING_START = 'EDIT_RECURRING_START';
const EDIT_RECURRING_ERROR = 'EDIT_RECURRING_ERROR';
const EDIT_RECURRING_SUCCESS = 'EDIT_RECURRING_SUCCESS';
const DELETE_RECURRING_START = 'DELETE_RECURRING_START';
const DELETE_RECURRING_ERROR = 'DELETE_RECURRING_ERROR';
const DELETE_RECURRING_SUCCESS = 'DELETE_RECURRING_SUCCESS';

export const customReportsReducer = (
  state: CustomReportsState,
  action: GlobalAction
): CustomReportsState => {
  const { payload, type } = action;
  switch (type) {
    case GET_CUSTOM_REPORTS_START:
    case GET_CUSTOM_REPORT_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_CUSTOM_REPORTS_ERROR:
    case GET_CUSTOM_REPORT_ERROR:
    case ADD_CUSTOM_REPORTS_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_CUSTOM_REPORTS_SUCCESS: {
      return {
        ...state,
        customReports: keyBy(payload.customReports, 'reportId'),
        loading: false,
        count: payload.count /*** SUS-781 changes ***/,
      };
    }
    case ADD_CUSTOM_REPORTS_SUCCESS:
    case GET_CUSTOM_REPORT_SUCCESS:
    case EDIT_CUSTOM_REPORTS_SUCCESS: {
      return {
        ...state,
        customReports: {
          ...state.customReports,
          [payload.customReport.reportId]: payload.customReport,
        },
        loading: false,
      };
    }
    case DELETE_CUSTOM_REPORTS_SUCCESS: {
      const { reportId } = payload;
      const copyState = { ...state };
      delete copyState.customReports[reportId];
      return copyState;
    }
    case ADD_RECURRING_SUCCESS: {
      const { recurring, reportId } = payload;
      const customReport = state.customReports[reportId];
      return {
        ...state,
        customReports: {
          ...state.customReports,
          [reportId]: {
            ...customReport,
            recurrings: [...(customReport.recurrings || []), recurring],
          },
        },
        loading: false,
      };
    }
    case EDIT_RECURRING_SUCCESS: {
      const { recurring, reportId } = payload;
      const customReport = state.customReports[reportId];
      const recurrings = (customReport.recurrings || []).map(r => {
        if (r.recurringId === recurring.recurringId) {
          return recurring;
        }
        return r;
      });
      return {
        ...state,
        customReports: {
          ...state.customReports,
          [reportId]: {
            ...customReport,
            recurrings,
          },
        },
        loading: false,
      };
    }
    case DELETE_RECURRING_SUCCESS: {
      const { reportId, recurringId } = payload;
      const copyState = { ...state };
      // @ts-ignore
      copyState.customReports[reportId].recurrings = copyState.customReports[
        reportId
      ].recurrings.filter(recurring => recurring.recurringId !== recurringId);
      return copyState;
    }
    default:
      return state;
  }
};

export const CUSTOM_REPORTS_ACTIONS = {
  GET_CUSTOM_REPORTS_START,
  GET_CUSTOM_REPORTS_ERROR,
  GET_CUSTOM_REPORTS_SUCCESS,
  GET_CUSTOM_REPORT_START,
  GET_CUSTOM_REPORT_ERROR,
  GET_CUSTOM_REPORT_SUCCESS,
  ADD_CUSTOM_REPORTS_START,
  ADD_CUSTOM_REPORTS_ERROR,
  ADD_CUSTOM_REPORTS_SUCCESS,
  EDIT_CUSTOM_REPORTS_START,
  EDIT_CUSTOM_REPORTS_ERROR,
  EDIT_CUSTOM_REPORTS_SUCCESS,
  DELETE_CUSTOM_REPORTS_START,
  DELETE_CUSTOM_REPORTS_ERROR,
  DELETE_CUSTOM_REPORTS_SUCCESS,
  ADD_RECURRING_START,
  ADD_RECURRING_ERROR,
  ADD_RECURRING_SUCCESS,
  EDIT_RECURRING_START,
  EDIT_RECURRING_ERROR,
  EDIT_RECURRING_SUCCESS,
  DELETE_RECURRING_START,
  DELETE_RECURRING_ERROR,
  DELETE_RECURRING_SUCCESS,
};
